import z from 'zod';

import {
  type SelectOption,
  SelectOptionSchema
} from '@/components/forms/components/form/writer/widgets/selectMenu/selectMenu.schema';

export const areOptionsArrayOfStrings = (value: unknown): value is string[] =>
  z.array(z.string()).safeParse(value).success;

export const areOptionsCorrect = (value: unknown): value is SelectOption[] =>
  z.array(SelectOptionSchema).safeParse(value).success;
